import { Snackbar } from '@shared/components/Snackbar';

import { CERTIFICATE_LABELS } from '../constants/labels';
import type { UseCertificateExportReturn } from '../hooks/useCertificateExport';

/**
 * Props for {@link CertificateExportSnackbars} — pass the return value of
 * {@link useCertificateExport} straight through.
 */
export type CertificateExportSnackbarsProps = Pick<
  UseCertificateExportReturn,
  | 'isExporting'
  | 'exportDotCount'
  | 'exportSuccessOpen'
  | 'closeExportSuccess'
  | 'exportErrorOpen'
  | 'closeExportError'
  | 'exportEmptyOpen'
  | 'closeExportEmpty'
>;

/**
 * The four snackbars of the certificate-list export flow (in-progress with
 * animated dots, success, error, nothing-to-export). Shared by the
 * technician and client certificate list views so the messages and
 * behaviour stay identical.
 */
export function CertificateExportSnackbars({
  isExporting,
  exportDotCount,
  exportSuccessOpen,
  closeExportSuccess,
  exportErrorOpen,
  closeExportError,
  exportEmptyOpen,
  closeExportEmpty,
}: CertificateExportSnackbarsProps) {
  return (
    <>
      <Snackbar
        open={isExporting}
        message={`${CERTIFICATE_LABELS.CERTS_TAB_EXPORTING}${'.'.repeat(exportDotCount)}`}
        variant="info"
        autoHideDuration={0}
        position="top-center"
      />
      <Snackbar
        open={exportSuccessOpen}
        message={CERTIFICATE_LABELS.CERTS_TAB_EXPORT_SUCCESS}
        variant="success"
        showCloseButton
        autoHideDuration={5000}
        onClose={closeExportSuccess}
        position="top-center"
      />
      <Snackbar
        open={exportErrorOpen}
        message={CERTIFICATE_LABELS.CERTS_TAB_EXPORT_ERROR}
        variant="error"
        showCloseButton
        onClose={closeExportError}
        position="top-center"
      />
      <Snackbar
        open={exportEmptyOpen}
        message={CERTIFICATE_LABELS.CERTS_TAB_EXPORT_EMPTY}
        variant="info"
        showCloseButton
        onClose={closeExportEmpty}
        position="top-center"
      />
    </>
  );
}
